var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameSp022(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 529.6 366",
    style: {
      enableBackground: "new 0 0 529.6 366"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#030646;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.2,41.3c33,0,33-6,66.1-6s33.1,6,66.1,6c33.1,0,33.1-6,66.1-6c33.1,0,33.1,6,66.1,6s33-6,66.1-6 s33,6,66.1,6s33-6,66.1-6s33,6,66.1,6v318c-33,0-33,6-66.1,6s-33-6-66.1-6s-33,6-66.1,6s-33-6-66.1-6s-33.1,6-66.1,6 s-33.1-6-66.1-6s-33.1,6-66.1,6s-33-6-66.1-6L0.2,41.3L0.2,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M529.1,359.3c-33,0-33,6-66.1,6s-33-6-66.1-6s-33,6-66.1,6s-33-6-66.1-6s-33.1,6-66.1,6s-33.1-6-66.1-6 s-33.1,6-66.1,6s-33-6-66.1-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.8,353.7c3.9-0.3,8.5-0.4,13.9-0.4c26.2,0,31.6,3.8,49.2,5.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.1,39.5c-11.1-1.8-18.8-4.1-39.6-4.1c-33.1,0-33.1,6-66.1,6s-33.1-6-66.1-6s-33.1,6-66.1,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.5,39.5c11.1-1.8,18.8-4.1,39.6-4.1c33,0,33,6,66.1,6c33,0,33-6,66.1-6s33,6,66.1,6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "__4",
    className: "st1",
    x1: 259.3,
    y1: 31,
    x2: 259.3,
    y2: 49.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8734",
    className: "st1",
    d: "M254.4,30.7v4.7c0,4-1.9,8.3-6.9,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8735",
    className: "st1",
    d: "M275.2,30.7v4.7c0,4,1.9,8.3,6.9,8.7"
  }), /*#__PURE__*/React.createElement("line", {
    id: "__5",
    className: "st1",
    x1: 270.3,
    y1: 31,
    x2: 270.3,
    y2: 49.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "__6",
    className: "st1",
    x1: 264.8,
    y1: 31.3,
    x2: 264.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8736",
    className: "st1",
    d: "M256.4,19.9l2.7-2.1l-2.7-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8737",
    className: "st1",
    d: "M273.3,19.9l-2.7-2.1l2.7-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8738",
    className: "st1",
    d: "M267,19.1l-2.2,3.4l-2.2-3.4H267L267,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8739",
    className: "st1",
    d: "M264.8,31.3c1.1,0,3.5-0.2,4.5-0.8c1.9,0.8,6.5,0.8,9-1.4c3.8,0.6,5.8-1,6.9-2.2 c-1.5-2.1-2.6-3.7-2.7-9.3c-0.1-8.1-6.1-16.9-17.7-16.9s-17.7,8.8-17.7,16.9c-0.1,5.6-1.1,7.2-2.7,9.3c1.1,1.2,3.1,2.8,6.9,2.2 c2.5,2.2,7.1,2.1,9,1.4C261.3,31.1,263.7,31.3,264.8,31.3L264.8,31.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_49",
    className: "st1",
    cx: 299.5,
    cy: 10.3,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_50",
    className: "st1",
    cx: 294.7,
    cy: 22.9,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_51",
    className: "st1",
    cx: 230.4,
    cy: 13.6,
    r: 7.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "_\\u5186\\u5F62_35",
    className: "st2",
    d: "M436.1,344.3c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8 S436.6,344.3,436.1,344.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u5186\\u5F62_36",
    className: "st2",
    d: "M379,353.6c-0.4,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8S379.4,353.6,379,353.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_35-2",
    className: "st2",
    cx: 93,
    cy: 345.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_36-2",
    className: "st2",
    cx: 150.2,
    cy: 354.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.4,353.7c-3.9-0.3-8.5-0.4-13.9-0.4c-26.2,0-31.6,3.8-49.2,5.3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_35-3",
    className: "st2",
    cx: 93,
    cy: 55.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_36-3",
    className: "st2",
    cx: 150.2,
    cy: 46.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.4,46.9c-3.9,0.3-8.5,0.4-13.9,0.4c-26.2,0-31.6-3.8-49.2-5.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4",
    className: "st2",
    d: "M-888.9-1646.8c-2.1,0.3-2.7-0.1-2.7-0.4s0.6-0.7,2.7-0.4c-0.3-2.1,0.1-2.7,0.4-2.7 s0.7,0.6,0.4,2.7c2.1-0.3,2.7,0.1,2.7,0.4s-0.6,0.7-2.7,0.4c0.3,2.1-0.1,2.7-0.4,2.7S-889.2-1644.7-888.9-1646.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547-2",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4-2",
    className: "st2",
    d: "M-1245.9-1646.8c2.1,0.3,2.7-0.1,2.7-0.4s-0.6-0.7-2.7-0.4c0.3-2.1-0.1-2.7-0.4-2.7 s-0.7,0.6-0.4,2.7c-2.1-0.3-2.7,0.1-2.7,0.4s0.6,0.7,2.7,0.4c-0.3,2.1,0.1,2.7,0.4,2.7S-1245.7-1644.7-1245.9-1646.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547-3",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4-3",
    className: "st2",
    d: "M-1245.9-1946.6c2.1-0.3,2.7,0.1,2.7,0.4s-0.6,0.7-2.7,0.4c0.3,2.1-0.1,2.7-0.4,2.7 s-0.7-0.6-0.4-2.7c-2.1,0.3-2.7-0.1-2.7-0.4s0.6-0.7,2.7-0.4c-0.3-2.1,0.1-2.7,0.4-2.7S-1245.7-1948.7-1245.9-1946.6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_547-4",
    transform: "translate(1332 1997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EB\\u30FC\\u30D7_544-4-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_8443-4-4",
    className: "st2",
    d: "M-888.4-1946.6c-2.1-0.3-2.7,0.1-2.7,0.4s0.6,0.7,2.7,0.4c-0.3,2.1,0.1,2.7,0.4,2.7 s0.7-0.6,0.4-2.7c2.1,0.3,2.7-0.1,2.7-0.4s-0.6-0.7-2.7-0.4c0.3-2.1-0.1-2.7-0.4-2.7S-888.7-1948.7-888.4-1946.6"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_35-4",
    className: "st2",
    cx: 436.6,
    cy: 55.5,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "_\\u5186\\u5F62_36-4",
    className: "st2",
    cx: 379.5,
    cy: 46.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.2,46.9c3.9,0.3,8.5,0.4,13.9,0.4c26.2,0,31.6-3.8,49.2-5.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameSp022);
export default __webpack_public_path__ + "static/media/frame_sp_02_2.a6a4f4afb64e58d12d6fd50eed846015.svg";
export { ForwardRef as ReactComponent };